import Video from 'components/Content/Media/Video/Video';

export default Video;
